// BaseListOptions 做為取列表共用的預設值
export const BaseListOptions = {
  sortBy: "",
  sortDesc: "0",
  page: "1",
  itemsPerPage: "15",
  keyword: "",
};

// GetBaseArgs 回傳跟預設值整合後的設置
export function GetBaseArgs(options = {}) {
  const retOptions = structuredClone(BaseListOptions);

  Object.keys(options).forEach((key) => {
    // 將 sortDesc 轉換為 -1(desc) or 1(asc) 或 0(無效)
    switch (key) {
      case "sortDesc":
        if (retOptions.sortBy?.length > 0) {
          retOptions.sortDesc = options[key] ? "-1" : "1";
        } else {
          retOptions.sortDesc = "0";
        }
        break;
      default:
        if (options[key]) retOptions[key] = options[key];
    }
  });

  const result = {};
  if (retOptions.keyword) result["ss="] = retOptions.keyword;
  if (retOptions.sortBy) result["sb="] = retOptions.sortBy;
  if (retOptions.sortDesc) result["sd="] = retOptions.sortDesc;
  if (retOptions.page) result["p="] = retOptions.page;
  if (retOptions.itemsPerPage) result["pp="] = retOptions.itemsPerPage;
  return result;
}
